import React, { Component } from "react";

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { faqCarrefour, faqAtacadao } from "./data";

// Material - UI
import { Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { AccordionWrapper, AccordionBox } from './components';
import { Headline } from "../../components/design/foundation/headline";

import { WrapperAccordion, Wrapper } from './styles';

function AccordionList(props) {

    return (
        <Accordion className="faq-accordion">
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{props.title}</Typography>

            </AccordionSummary>
            <AccordionDetails>
                <Typography style={{ wordBreak: 'break-word' }}>{props.children}</Typography>
            </AccordionDetails>
        </Accordion>
    );
}

class Help extends Component {

    render() {

        const faq = {
            atacadao: faqAtacadao,
            carrefour: faqCarrefour
        }

        return (
            <section id="view_help">

                <div className="_med-container">

                    <Wrapper>
                        <Headline
                            type="medium"
                            title="FAQ"
                            subTitle="Central de benefícios"
                            textAlign="left"
                        />

                        <WrapperAccordion>
                            {
                                this.props.website ? faq[this.props.website].map(({ empresa, categorias }, i) => {
                                    return (
                                        <AccordionWrapper key={`${i}-${empresa}`} title={empresa}>
                                            {categorias.map(({ nome, perguntas }, i) => (

                                                <AccordionBox key={`${i}-${nome}`} title={nome}>
                                                    <div className="_wrap-topics">
                                                        <div className="_topics">
                                                            <ul className="_topics-list">

                                                                {perguntas.map(({ pergunta, resposta }, i) => (
                                                                    <li key={`${i}-${pergunta}`} >
                                                                        <AccordionList title={pergunta}>
                                                                            <div dangerouslySetInnerHTML={{ __html: resposta }} />
                                                                        </AccordionList>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </AccordionBox>
                                            ))}
                                        </AccordionWrapper>
                                    )
                                }
                                ) : ''
                            }

                        </ WrapperAccordion>
                    </ Wrapper>

                </div>

            </section>
        );
    }
}


const mapStateToProps = (state) => ({
    site_properties: state.websiteReducer.site_properties,
    website: state.websiteReducer.website
})

export default withRouter(connect(mapStateToProps, {})(Help));